module.exports = __webpack_public_path__ + "assets/img/3bc5bd0a8794e12e4c99347c9b241566.svg";